
// Popper.js
window._ = require('lodash');
window.Popper = require('popper.js').default;
import VueAnime from 'vue-animejs';
import VueKinesis from 'vue-kinesis'
 
Vue.use(VueKinesis)
Vue.use(VueAnime)

// jQuery
window.$ = window.jQuery = require('jquery');

// Bootstrap 4
require('bootstrap');

// Axios
window.axios = require('axios');

/*
|--------------------------------------------------------------------------
| Vue.js
|--------------------------------------------------------------------------
*/
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
